/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIOrganization
 */
export interface APIOrganization {
    /**
     * 
     * @type {string}
     * @memberof APIOrganization
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrganization
     */
    billingAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrganization
     */
    shippingAddress?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIOrganization
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIOrganization
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIOrganization
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrganization
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrganization
     */
    website?: string;
}

/**
 * Check if a given object implements the APIOrganization interface.
 */
export function instanceOfAPIOrganization(value: object): value is APIOrganization {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIOrganizationFromJSON(json: any): APIOrganization {
    return APIOrganizationFromJSONTyped(json, false);
}

export function APIOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOrganization {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'billingAddress': json['billing_address'] == null ? undefined : json['billing_address'],
        'shippingAddress': json['shipping_address'] == null ? undefined : json['shipping_address'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
        'vatNumber': json['vat_number'] == null ? undefined : json['vat_number'],
        'website': json['website'] == null ? undefined : json['website'],
    };
}

export function APIOrganizationToJSON(value?: Omit<APIOrganization, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'billing_address': value['billingAddress'],
        'shipping_address': value['shippingAddress'],
        'name': value['name'],
        'vat_number': value['vatNumber'],
        'website': value['website'],
    };
}

